import React from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { Deputati } from 'pages'
import { connect } from 'react-redux'
import loadingStatuss from 'actions/LoadingActions'


const QUERY = gql`
  query DeputatiQuery($lang: String!, $domes_partija: [String], $domes_piederiba: [String], $perpage: Int, $page: Int, $orderby: [String], $order: [String]) {
      dome(lang: $lang, domes_partija: $domes_partija, domes_piederiba: $domes_piederiba, perpage: $perpage, page: $page, orderby: $orderby, order: $order) {
        posts {
          _id
          path
          title
          path
          content
          acf
          images {
            src
            thumb(size: ["card-default","deputats"]) {
              url
              retina
              width
              height
            }
          }
          terms {
            domes_partija {
              name
            }
            domes_piederiba {
              name
            }
          }
        }
      }
      teksti(lang: $lang, _id:["partija","foto_medijiem"]) {
          _id
          text
      }
  }
`
const ITEMS_PER_PAGE = 999
const queryOptions = {
  options: props => {
    let { lang } = props
    return ({
      fetchPolicy: 'cache-first',
      variables: {
        lang: (lang || 'lv'),
        domes_partija: null,
        domes_piederiba: 'domes-vadiba',
        perpage: ITEMS_PER_PAGE,
        // page: $page,
        orderby: 'menu_order',
        order: 'asc'
      }
    })
  },
  props: props => {
    const { data, lang } = props
    const { data: {
                    loading,
                    dome,
                    teksti,
                    ...rest
                  }
          } = props;
    return {
      lang: props.ownProps.lang,
      loading,
      data: {
        dome,
        teksti,
        type:'domes-vadiba',
        page:props.ownProps.init_page
      }
    }
  }
}


class PageDomesDeputati extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      page: 0,
      total: 0
    }
  }


  componentWillMount() {
    if(this.props.loading){
        this.props.loadingStatuss({_id:this.props.path+'__',loading:true})
    } else if(!this.props.loading && this.props.global_loading && this.props.global_loading[this.props.path+'__']===true){
        this.props.loadingStatuss({_id:this.props.path+'__',loading:false})
    }
  }

  componentWillReceiveProps(nextProps) {
     if(nextProps.loading && nextProps.global_loading[nextProps.path+'__']===false){
        nextProps.loadingStatuss({_id:nextProps.path+'__',loading:true})
     } else if(!nextProps.loading && nextProps.global_loading[nextProps.path+'__']===true){
        nextProps.loadingStatuss({_id:nextProps.path+'__',loading:false})
     }
  }



  render() {
    const props = this.props
    if (props.loading ) {
      return null
    }
    return (<Deputati data={props.data} lang={props.lang} path={props.history.location.pathname} />)
  }
}


const mapStateToProps = state => {
  // console.log(state)
  return ({
    global_loading: state.global_loading,
  })
}
const mapDispatchToProps = dispatch => ({
  loadingStatuss: LOADING => {
    dispatch(loadingStatuss(LOADING))
  }
})

export default compose(
  graphql(QUERY, queryOptions),
  connect(mapStateToProps, mapDispatchToProps)
)(PageDomesDeputati)




// WEBPACK FOOTER //
// ./src/components/PageDomesVadiba.js